import { defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IlIcon } from '../../../IlIcon/index.js';
import { cssClassPrefix } from '../../../../shared/constants/generalConstants.js';
import { isEnterKeyPressed, isSpaceKeyPressed } from '../../../../shared/utils/keysUtils.js';

var BASE_CSS = "".concat(cssClassPrefix, "-header-actions__menu-icon");
var IlHeaderMenuIcon = function IlHeaderMenuIcon(props) {
  var onClick = props.onClick,
    isOpen = props.isOpen,
    ariaLabel = props.ariaLabel;
  var onKeyPressHandler = function onKeyPressHandler(e) {
    // Toggle the sidebar on Tab and Enter for accessability
    if (isEnterKeyPressed(e) || isSpaceKeyPressed(e)) {
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-label": ariaLabel,
    onClick: onClick,
    onKeyPress: onKeyPressHandler,
    role: "button",
    className: classNames(BASE_CSS, _defineProperty({}, "".concat(BASE_CSS, "--open"), isOpen)),
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement(IlIcon, {
    name: "menu",
    className: "".concat(BASE_CSS, "-svg")
  }));
};
IlHeaderMenuIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  ariaLabel: PropTypes.string.isRequired
};

export { IlHeaderMenuIcon as default };
